import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  number_of_employees: Yup.string().required("Number of employee is required!"),
  days_per_week: Yup.string().required("Days per week is required!"),
  seasonality: Yup.string().required("Business Seasonality is required!"),
});
